export enum ContentDetailsFormField {
  approvedByRegulator = 'approvedByRegulator',
  regulatorApprovalDate = 'regulatorApprovalDate',
  authorisedDate = 'authorisedDate',
  reasonsForSubmission = 'reasonsForSubmission',
  details = 'details',
  isRegulatorApproved = 'isRegulatorApproved',
}

export enum ContentDetailsMode {
  View = 'view',
  Update = 'update',
  Create = 'create'
}
